<template>
  <!-- Marks AO's own chrome for the platform e2e suite; App.vue drops this component when embedded. -->
  <v-footer data-rtls-product-chrome app height="40px" class="elevation-8 assortment-toolbar">
    <v-btn
      variant="text"
      class="nav-link pa-0 mr-6 text-decoration-underline text-none"
      color="white"
      :href="termsOfUse"
    >
      <span class="footer-text">
        {{ $t('footer.termsOfUse') }}
      </span>
    </v-btn>
    <v-btn
      variant="text"
      class="nav-link pa-0 mr-6 text-decoration-underline text-none"
      color="white"
      :href="privacyNote"
    >
      <span class="footer-text">
        {{ $t('footer.privacyNote') }}
      </span>
    </v-btn>
    <template v-if="isManageCookiesVisible">
      <v-btn
        variant="text"
        class="nav-link pa-0 mr-6 text-decoration-underline text-none"
        color="white"
        :href="cookieNotice"
      >
        <span class="footer-text">
          {{ $t('footer.cookieNotice') }}
        </span>
      </v-btn>
      <v-btn
        variant="text"
        class="nav-link pa-0 mr-6 text-decoration-underline text-none"
        color="white"
        @click="onManageCookiesClick"
      >
        <span class="footer-text">
          {{ $t('footer.manageCookiesButtonTitle') }}
        </span>
      </v-btn>
    </template>
    <span class="footer-text">
      {{ copyWrightOwText }}
    </span>
    <v-spacer />
    <v-btn variant="text" class="text-none ml-5" :href="owLink">
      <v-sheet class="assortment-toolbar footer-text"> {{ $t('footer.solutionFrom') }}: </v-sheet>
      <v-spacer class="offset-md-1" />
      <v-sheet class="assortment-toolbar ow-logo">
        <img :src="owLogo" height="12px" width="103px" alt="Oliver Wyman" />
      </v-sheet>
    </v-btn>
  </v-footer>
</template>

<script setup>
import { computed } from 'vue';
import { get } from 'lodash';
import dayjs from 'dayjs';
import { useContextStore } from '@/stores/context';
import owLogo from '@/assets/logo-oliver-wyman-white.svg';

const owLink =
  'https://www.oliverwyman.com/our-expertise/industries/retail-and-consumer-goods/retail-elements.html';
const termsOfUse =
  'https://www.oliverwyman.com/content/dam/oliver-wyman/v2/legal/OW-General-Web-Portal-ToU.pdf';
const privacyNote = 'https://www.oliverwyman.com/policies/privacy-notice-platforms.html';
const cookieNotice = 'https://www.oliverwyman.com/policies/cookie-notice.html';

const context = useContextStore();
const onManageCookiesClick = () => Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
const isManageCookiesVisible = computed(() =>
  get(context, 'clientConfig.features.showStrictlyNecessaryCookiesNotice')
);

const copyWrightOwText = `Copyright © ${dayjs().format('YYYY')} Oliver Wyman`;
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.assortment-toolbar {
  background-color: $assortment-header-footer-dark-colour;
  z-index: 199 !important;
  text-decoration-color: $assortment-header-footer-text-colour;
  color: $assortment-header-footer-text-colour;
}

.v-btn:hover:before,
.v-btn:focus:before {
  color: transparent;
}

.footer-text {
  font-size: 1.25rem;
  color: $assortment-header-footer-text-colour;
  text-decoration-color: $assortment-header-footer-text-colour;
}
.ow-logo {
  padding-top: 5px;
  margin-left: 2px;
}
</style>
